// extracted by mini-css-extract-plugin
export var addButton = "_d5-4";
export var contentBlockImage = "_d5-i";
export var contentBlockWidgetPreview = "_d5-g";
export var fulfillmentCutoffWidgetPreview = "_d5-9";
export var imageBackdrop = "_d5-6";
export var imageIcon = "_d5-8";
export var lowProfileImageContainer = "_d5-b";
export var lowProfileImageIcon = "_d5-f";
export var lowProfileImageIconContainer = "_d5-e";
export var lowProfileImagePlaceholder = "_d5-d";
export var lowProfileProductImage = "_d5-c";
export var lowProfileProductUpsellWidgetPreview = "_d5-a";
export var productCard = "_d5-5";
export var productImage = "_d5-7";
export var productReviewsWidgetPreview = "_d5-h";
export var progressBar = "_d5-1";
export var progressBarFill = "_d5-2";
export var progressBarTrack = "_d5-3";
export var shippingOptionWidgetPreview = "_d5-j";
export var shippingUpsellProgressBar = "_d5-k";
export var thresholdUpsellWidgetPreview = "_d5-0";